var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-grm-comp": "RoomTestbankExamTable" } },
    [
      _c("div", { staticClass: "h-full flex flex-col hidden lg:flex" }, [
        _c("table", { staticClass: "test-bank-table" }, [
          _vm._m(0),
          _c("thead", { staticClass: "h-8 bg-gray-200" }, [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("common.number")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("setting.name.title")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.number.question")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("link.regDate")))]),
              _c("th"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "max-h-full overflow-y-auto scrollbar-hide" },
          [
            _c("table", { staticClass: "test-bank-table" }, [
              _vm._m(1),
              _c(
                "tbody",
                [
                  [
                    _vm._l(_vm.testbankExamList?.content, function (exam, i) {
                      return _c(
                        "tr",
                        {
                          key: exam.bankExamId,
                          staticClass:
                            "cursor-pointer transition hover:bg-gray-100",
                          on: {
                            click: function ($event) {
                              return _vm.onSelectExam(exam)
                            },
                          },
                        },
                        [
                          _c("td", [_vm._v(_vm._s(_vm.testbankExamNum(i)))]),
                          _c("td", [_vm._v(_vm._s(exam.examTitle))]),
                          _c("td", [_vm._v(_vm._s(exam.questionCnt))]),
                          _c("td", [_vm._v(_vm._s(exam.regDate))]),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "flex justify-center gap-x-1" },
                              [
                                _c(
                                  "GrmBtn",
                                  {
                                    attrs: { size: "xs", color: "yellow" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.onCopyExam(exam)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.copy")))]
                                ),
                                _c(
                                  "GrmBtn",
                                  {
                                    attrs: { size: "xs" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.onEditExam(exam)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.edit")))]
                                ),
                                _c(
                                  "GrmBtn",
                                  {
                                    attrs: { size: "xs", color: "red" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.onDeleteExam(exam)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.delete")))]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    }),
                    !_vm.testbankExamList?.content?.length
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "5" },
                            },
                            [_vm._v(_vm._s(_vm.$t("testBank.alert.paper")))]
                          ),
                        ])
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex flex-col gap-2 lg:hidden" },
        _vm._l(_vm.testbankExamList?.content, function (exam, i) {
          return _c(
            "div",
            { key: exam.bankExamId, staticClass: "p-2 rounded bg-gray-100" },
            [
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("common.number"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(i + 1)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("setting.name.title"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(exam.examTitle)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.number.question"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(exam.questionCnt)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("link.regDate"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(exam.regDate)),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "w-full flex gap-x-1" },
                [
                  _c(
                    "GrmBtn",
                    {
                      staticClass: "flex-1",
                      attrs: { size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.onSelectExam(exam)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("setting.disclosure.password.see")))]
                  ),
                  _c(
                    "GrmBtn",
                    {
                      staticClass: "flex-1",
                      attrs: { size: "sm", color: "yellow" },
                      on: {
                        click: function ($event) {
                          return _vm.onCopyExam(exam)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.copy")))]
                  ),
                  _c(
                    "GrmBtn",
                    {
                      staticClass: "flex-1",
                      attrs: { size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.onEditExam(exam)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.edit")))]
                  ),
                  _c(
                    "GrmBtn",
                    {
                      staticClass: "flex-1",
                      attrs: { size: "sm", color: "red" },
                      on: {
                        click: function ($event) {
                          return _vm.onDeleteExam(exam)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.delete")))]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      !_vm.testbankExamList?.content?.length
        ? _c("div", { staticClass: "lg:hidden" }, [
            _c(
              "p",
              { staticClass: "text-center p-2 rounded bg-gray-100 text-sm" },
              [_vm._v(_vm._s(_vm.$t("testBank.alert.paper")))]
            ),
          ])
        : _vm._e(),
      _c("GrmPagination", {
        staticClass: "mt-3",
        attrs: { pageInfo: _vm.testbankExamList?.pageInfo },
        on: {
          paging: (page) => {
            _vm.getTestbankExamList({ page })
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "3%" } }),
      _c("col", { attrs: { width: "12%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "12%" } }),
      _c("col", { attrs: { width: "6%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "3%" } }),
      _c("col", { attrs: { width: "12%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "12%" } }),
      _c("col", { attrs: { width: "6%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }